var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-content-wrapper"},[_c('breadcrumbs',{attrs:{"breadcrumbs":_vm.breadcrumbs}}),_vm._l((_vm.groups),function(group,index){return _c('dashboard-navigation-group',{key:index,attrs:{"group":group}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }